<div class="slat-assessment-status-content-container">
  <div class="mat-headline-4 slat-assessment-status-text-container">
    {{ 'Set assessment status' | translate }}
  </div>

  <div class="mt-3">
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="slatAssessmentStatus"
        [value]="SlatAssessmentStatus.Completed"
        [checked]="selectedStatus === SlatAssessmentStatus.Completed"
        (change)="onStatusChange($event.target.value)"
        id="status-completed"
      />
      <label class="form-check-label" for="status-completed">
        {{ 'Completed' | translate }}
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="slatAssessmentStatus"
        [value]="SlatAssessmentStatus.UnableToComplete"
        [checked]="selectedStatus === SlatAssessmentStatus.UnableToComplete"
        (change)="onStatusChange($event.target.value)"
        id="status-unable"
      />
      <label class="form-check-label" for="status-unable">
        {{ 'Unable to complete' | translate }}
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="slatAssessmentStatus"
        [value]="SlatAssessmentStatus.UnsuitableForStandardAssessment"
        [checked]="
          selectedStatus ===
          SlatAssessmentStatus.UnsuitableForStandardAssessment
        "
        (change)="onStatusChange($event.target.value)"
        id="status-unsuitable"
      />
      <label class="form-check-label" for="status-unsuitable">
        {{ 'Unsuitable for standard assessment' | translate }}
      </label>
    </div>
  </div>

  <div class="slat-assessment-status-button">
    <app-action-button
      kind="filled"
      color="primary"
      size="extra-wide"
      (onClick)="close('continue')"
      >{{ 'Confirm' | translate }}
    </app-action-button>
  </div>
  <div class="slat-assessment-status-button">
    <app-action-button
      kind="outline"
      color="primary"
      size="extra-wide"
      (onClick)="close('cancel')"
      >{{ 'Cancel' | translate }}
    </app-action-button>
  </div>
</div>
